module.exports = __webpack_public_path__ + "img/plant-tree.ba1a1c7c.svg";